class PageHipHopAnimationController {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener('DOMContentLoaded', (event) => {

      ///////////////////////////////////////////////////////
      // PRESENTATION IMAGE ANIMATION

      if (window.screen.width >= 600) {
        if (!!window.IntersectionObserver) {
          let presentationImage = new IntersectionObserver((entries, presentationImage) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('presentation-image-animation');
                presentationImage.unobserve(entry.target);
              }
            });
          }, {
            rootMargin: "0px 0px -200px 0px"
          });
          document.querySelectorAll('.animate-presentation-image').forEach(box => {
            presentationImage.observe(box)
          });
          ///////////////////////////////////////////////////////

        }
      } else {
        if (!!window.IntersectionObserver) {
          let presentationImage = new IntersectionObserver((entries, presentationImage) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('presentation-image-animation');
                presentationImage.unobserve(entry.target);
              }
            });
          }, {
            rootMargin: "0px 0px 0px 0px"
          });
          document.querySelectorAll('.animate-presentation-image').forEach(box => {
            presentationImage.observe(box)
          });
          ///////////////////////////////////////////////////////

        }
      }
    });
  }
}

export default PageHipHopAnimationController;